import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableStatic';
import { Badge } from '@uhg-abyss/web/ui/Badge';
import React, { useMemo } from 'react';

import configuration from './includes/configuration.json';

/**
 * Table
 *
 * @TODO - Needs description.
 *
 * @param rows
 * @returns {Element}
 * @constructor
 */
export function Table({ rows }) {
  /**
   * renderCellAmount
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellAmount = ({ cell }) => {
    return <React.Fragment>{Number(cell?.value).toLocaleString('en-US')}</React.Fragment>;
  };

  /**
   * renderCellScore
   *
   * @TODO Needs description.
   *
   * @param cell
   * @returns {JSX.Element}
   */
  const renderCellScore = ({ cell }) => {
    const badgeVariants = {
      G: 'success',
      R: 'error',
      Y: 'warning',
    };

    return (
      <Badge outline variant={badgeVariants[cell?.value?.toUpperCase()]}>
        {cell?.value}
      </Badge>
    );
  };

  /**
   * Columns for table.
   */
  const columns = useMemo(() => {
    return configuration?.initialColumns.map((item) => {
      const column = item;

      if (column.Header === 'Score') {
        column.Cell = renderCellScore;
      }

      if (column.Header === 'Amount') {
        column.Cell = renderCellAmount;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/RiskScore/components/Table/Table.jsx">
      <TableComponent
        {...{
          columns,
          configuration,
          rows,
        }}
      />
    </ErrorHandler>
  );
}
